import {
  Avatar,
  Button,
  FormControl,
  TextField,
  Typography,
  InputAdornment,
  IconButton
} from '@mui/material';
``;
import { useEffect, useState } from 'react';
import {
  colorLinkGrey,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { formatDateTimeAgo } from '../../utils/utils';
import { addComments, gamification } from '../../redux/reducers/resourcesSlice';
import { useSelector, useDispatch } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';

const Comments = ({
  key,
  comment,
  index,
  handleShow,
  contentId,
  isChildDiv = false,
  isShowAllComments,
  parentId,
  commentPoints,
  allowPoints
}) => {
  const [comments, setComments] = useState('');
  const [tempComments, setTemComments] = useState('');
  const [replyIds, setReplyIds] = useState([]);
  const dispatch = useDispatch();
  const { authData } = useSelector(state => state.auth);

  const userId = authData?.userId;
  const userName = authData?.userName;

  const { isAddCommentsLoading, isAddCommentsSuccess, addCommentsResponse } =
    useSelector(state => state.resource);

  const handleReplyClick = id => {
    setComments('');
    setTemComments('');
    handleShow(id);
  };

  const circleStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: '#c9c9c9',
    color: 'white',
    fontSize: '18px',
    marginRight: '5px'
  };

  const handleCommentChange = (e, username) => {
    const { value } = e.target;
    if (value !== username) {
      if (value?.length < 201) {
        const commentText = value.replace(username + ' ', '');
        setComments(commentText);
        setTemComments(`@${comment.userName} ${value}`);
      }
    }
  };

  const handleAddComment = () => {
    let payload = {
      message: tempComments || '',
      contentId: contentId || 0,
      userId: userId || 0,
      loggedInUserName: userName || '',
      parentId: parentId || 0
    };

    dispatch(addComments({ payload }));
    if (authData?.role === 'I am a student') {
      if (allowPoints) {
        let gamificationPayload = {
          userId: userId || 0,
          contentId: contentId || 0,
          point: commentPoints || 0,
          type: 'comment',
          loggedInUserName: userName || ''
        };
        dispatch(gamification({ gamificationPayload }));
      }
    }
  };

  useEffect(() => {
    if (!isAddCommentsLoading && isAddCommentsSuccess && addCommentsResponse) {
      setComments('');
      setTemComments('');
    }
  }, [isAddCommentsLoading, isAddCommentsSuccess]);

  const handleMessage = message => {
    return message.split(' ').map((word, index) => {
      if (word.startsWith('@')) {
        // const username = word.slice(1);
        return (
          <span
            key={index}
            // href={`/profile/${username}`}
            style={{
              // color: '#007BFF',
              fontWeight: 500,
              textDecoration: 'none',
              marginRight: 4
            }}
          >
            {word}{' '}
          </span>
        );
      }

      return <span key={index}>{word} </span>;
    });
  };

  const handleShowComments = id => {
    let tempReplyIds = [...replyIds];

    if (tempReplyIds.includes(id)) {
      tempReplyIds = tempReplyIds.filter(item => item !== id);
    } else {
      tempReplyIds.push(id);
    }
    setReplyIds(tempReplyIds);
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          marginBottom: '12px',
          marginTop: `${!isChildDiv && '20px'}`
        }}
        key={index}
      >
        {comment?.profileImageUrl ? (
          <Avatar
            src={comment?.profileImageUrl || ''}
            alt={comment?.profileImageUrl || ''}
            sx={{ width: 32, height: 32, marginRight: 1 }}
          />
        ) : (
          <div style={circleStyle}>
            {comment
              ? comment?.userName?.split(' ')[0].charAt(0).toUpperCase()
              : 'A'}
          </div>
        )}
        <div
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '20px',
                color: colorLinkGrey
              }}
            >
              {comment?.userName || ''}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '18px',
                color: colorTextGrey,
                marginLeft: '10px'
              }}
            >
              {comment?.createdAt ? formatDateTimeAgo(comment?.createdAt) : '-'}
            </Typography>
          </div>
          <Typography
            style={{
              fontFamily: 'Lato',
              fontSize: '14px',
              lineHeight: '18px',
              fontWeight: 500,
              color: colorLinkGrey,
              marginTop: '5px'
            }}
          >
            {comment?.message ? handleMessage(comment?.message) : ''}
          </Typography>

          <Typography
            style={{
              fontSize: '10px',
              fontWeight: 700,
              lineHeight: '12px',
              fontFamily: 'Lato',
              color: colorTextBlack,
              textDecoration: 'underline',
              cursor: 'pointer',
              marginTop: '3px',
              width: '3rem'
            }}
            onClick={() => handleReplyClick(index)}
          >
            Reply
          </Typography>
          {comment?.isShow && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                marginTop: '10px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%'
                }}
              >
                <FormControl variant="outlined" fullWidth size="small">
                  <TextField
                    name="comments"
                    placeholder="Write comment here..."
                    variant="outlined"
                    size="small"
                    value={comments}
                    onChange={e =>
                      handleCommentChange(e, '@' + comment.userName)
                    }
                    onKeyDown={e => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        if (comments?.length) {
                          handleAddComment();
                        }
                      }
                    }}
                    inputProps={{ maxLength: 300 }}
                    sx={{
                      '& textarea': {
                        resize: 'none',
                        '&::-webkit-scrollbar-track': {
                          background: '#f5f5f5',
                          borderRadius: '10px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#4E565F',
                          borderRadius: '10px',
                          border: '2px solid #4E565F'
                        }
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <span style={{ fontWeight: 'bold', marginLeft: 12 }}>
                            @{comment.userName}
                          </span>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => handleShow(null)}
                            edge="end"
                          >
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
                <Typography
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    fontFamily: 'Lato',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: colorLinkGrey
                  }}
                >
                  {comments?.length}/200
                </Typography>
              </div>

              <Button
                variant="contained"
                disabled={!comments?.length}
                sx={{
                  px: 4,
                  borderWidth: 2,
                  width: '90px',
                  borderRadius: '8px',
                  marginLeft: '10px'
                }}
                onClick={handleAddComment}
              >
                Add
              </Button>
            </div>
          )}
        </div>
      </div>

      {comment?.replies && comment.replies.length > 0 && (
        <div style={{ marginLeft: '40px' }}>
          {!replyIds.includes(parentId)
            ? comment?.replies
                ?.slice(0, 1)
                .map(reply => (
                  <Comments
                    key={reply.id}
                    comment={reply}
                    index={reply.id}
                    handleShow={handleShow}
                    isChildDiv={true}
                    contentId={contentId}
                    isShowAllComments={isShowAllComments}
                    parentId={parentId}
                    commentPoints={commentPoints}
                    allowPoints={allowPoints}
                  />
                ))
            : comment?.replies?.map(reply => (
                <Comments
                  key={reply.id}
                  comment={reply}
                  index={reply.id}
                  handleShow={handleShow}
                  isChildDiv={true}
                  contentId={contentId}
                  isShowAllComments={isShowAllComments}
                  parentId={parentId}
                  commentPoints={commentPoints}
                  allowPoints={allowPoints}
                />
              ))}

          {comment?.replies?.length > 1 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                marginLeft: '40px'
              }}
              onClick={() => handleShowComments(parentId)}
            >
              <Typography
                style={{
                  fontSize: '14px',
                  lineHeight: '18px',
                  fontWeight: 700,
                  fontFamily: 'Lato',
                  color: colorTextBlack
                }}
              >
                {!replyIds.includes(parentId)
                  ? 'View All Reply'
                  : 'View Less Reply'}
              </Typography>
              {!replyIds.includes(parentId) ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowUpIcon />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Comments;
